import React from 'react';
import { Card, Stack } from 'react-bootstrap';
import { InsurancePolicyUserSearchForm } from './insurance-policy-user-search-form';
import { InsurancePolicyUserList } from './insurance-policy-user-list';

const SearchInsurancePolicyUserPage = () => {
  return (
    <main>
      <h5 className="mb-4">Search policy holders</h5>
      <Stack gap={4}>
        <Card>
          <Card.Body>
            <InsurancePolicyUserSearchForm />
          </Card.Body>
        </Card>
        <Card>
          <Card.Body>
            <InsurancePolicyUserList />
          </Card.Body>
        </Card>
      </Stack>
    </main>
  );
};

export { SearchInsurancePolicyUserPage };
